// export const CURRENCY_KIND = Object.freeze({
//     USDT: { name: 'Tether', unit: 'USDT', icon: UsdtIcon },
//     YBB: { name: 'YBB', unit: 'YBB', icon: YbbIcon }
// })
// enum CurrencyKind {
//     USDT = 'USDT',
//     YBB = 'YBB'
// }

import { PageInfo } from './common'

export enum YubiRole {
  Merchant
}

export enum CurrencyKind {
  //Crypto
  Bitcoin,
  Ethereum,
  Tether,
  Trx,

  // Fiat
  CNY,
  YBB,

  //#NOTE this is for Currency default only
  NullCoin = 999999999
}

export interface Currency {
  __typename: 'Currency'
  kind: string
  value: string
}
export interface Wallet {
  __typename: 'Wallet'
  balance: Currency
  bonusBalance: Currency
  frozenBalance: Currency
  lockedBalance: Currency
}
export interface WalletEvent {
  __typename: 'WalletEvent'
  eventNumber: string
  internalKey: string
  aggregateId: string
  kind: string
  when: string
  amount: Currency
  correlationId: string
  subtotal: number
  fee: number
  metadata: any
  metadataExt: any
}
export interface WalletEventEdge {
  __typename: 'WalletEventEdge'
  cursor: string
  node: WalletEvent
  id: string
}

export enum WalletEventKind {
  Deposited,
  Withdrawn,
  Reserved,
  Paid,
  Refunded,
  Transferred, // 5
  Received,
  Debited,
  Credited,
  Locked,
  Unlocked, // 10
  Frozen,
  Unfrozen,
  FeeCharged,
  FeeReturned,
  Brokerage, // 15
  WithdrawnConfirmed,
  WithdrawnRejected,
  WithdrawnCanceled,
  DepositAttempt,
  SellOrderReserved, // 20
  SellOrderRefunded,
  BuyOrderCompleted,
  SellOrderCompleted,
  SellOrderRebated,
  ExchangedIn, // 25
  ExchangedOut,
  BuyPrizePoolPoint,
  PrizeRewarded,
  StartPrizePoolSettle,
  BonusActivityRewarded, // 30
  SellOrderRemained,
  DebitAttempt,
  DebitCompleted,
  DebitRejected,
  TransferredWithBonus = 36
}
export interface UserWalletEventsConnection {
  __typename: 'UserWalletEventsConnection'
  edges: WalletEventEdge[]
  pageInfo: PageInfo
}
export interface AssetRequest {
  __typename: 'AssetRequest'
  number: number
  systemId: string
  time: string
  actionFlag: number
  status: number
  userId: string
  managerId: string
  network: number
  accountAddr: string
  managerAddr: string
  amount: Currency
  fee: Currency
  txHash: string
  memo: string
  finishedAt: string
  processedAt: string
  version: number
  feeVersion: number
  metadataExt: any
  userName: string
}
